import { BsArrowDownRightCircle } from "react-icons/bs";
//import bannerImg from "../../../assets/bannerImg.jpg";
//import bannerVido from "../../../assets/videoplayback.webm";
import { useNavigate } from "react-router";
import commonObj from '../../../utils/Common';
import config from '../../../config/index';


const Banner = ({ catRef }) => {
  const navigate = useNavigate();

  return (
    <main className=" justify-between items-center mb-5  relative">
         <div className=" flex justify-between items-center space-x-4 relative mainImg-div">
         <section className="max-w-xl sm:mx-0 mx-2 w-full lg:w-1/2 mainImg-sec">
        <img src={config.url+'bannerImg.jpg'} alt="bannerImg" className="w-full h-full image-box-area" />
        {/* <h1 className="text-6xl  sm:text-7xl lg:text-8xl font-bold  py-3 w-full ">
        Buy & Sell Made Easy 
        </h1> */}
      
      </section>
          <section className="max-w-xl  sm:mx-0  mx-2 w-full px-2 py-2  lg:w-1/2 lg:flex justify-end vido-sec">
        {/* <img src={bannerImg} alt="bannerImg" className="w-1/1 h-full image-box-area" /> */}
        <video width="600" height="600" className="w-1/1 h-full image-box-area" controls >
        <source src={config.url+'videoplayback.webm'} type="video/mp4"/>
      </video>
      </section>
          </div> 
     
          <section className="flex flex flex-col items-left w-full lg:w-1/2 xl:w-1/2 buysell-sec">
          <p className="py-1 text-md  text-gray-600">
        {commonObj.getLabel('BuySell_Text_1')}
          <br />
          {commonObj.getLabel('BuySell_Text_2')}
        </p>
        <div className=" flex  items-left lg:w-1/2 xl:w-1/2   space-x-4 relative buysell-div">
        {/* <button
            className="btn-primary   text-sm md:text-base"
            onClick={() => navigate("/products")}
          >
            {commonObj.getLabel('Start_Shopping')}
          </button> */}
          <button
            className="p-1 flex items-center"
            onClick={() =>
              catRef.current.scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="mx-2 text-sm md:text-base">{commonObj.getLabel('Explore_More')}</span>{" "}
            <BsArrowDownRightCircle className="text-lg" />
          </button>

        </div>

        </section>
    </main>
  );
};

export default Banner;
